import React, { createContext, useContext, useRef, useState } from "react";

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState(null);
  const timer = useRef(null);

  const showToast = (message) => {
    clearTimeout(timer.current);
    setToast(message);
    timer.current = setTimeout(() => setToast(null), 4000);
  };

  return (
    <ToastCtx.Provider value={showToast}>
      {children}
      {toast && (
        <div
          className="fixed top-6 left-1/2 z-50 -translate-x-1/2 rounded border border-border bg-surface px-4 py-3 text-sm text-text-primary shadow-xl"
          role="status"
          aria-live="polite"
        >
          {toast}
        </div>
      )}
    </ToastCtx.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastCtx);
  if (!ctx) throw new Error("useToast must be used within ToastProvider");
  return ctx;
}
